<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type AlertVariants, alertVariants } from '.'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  variant?: AlertVariants['variant']
  title?: string
  description?: string
  inlineActions?: boolean
}>()
</script>

<template>
  <div
    :class="cn(alertVariants({ variant, inlineActions }), props.class)"
    role="alert"
  >
    <slot>
      <div class="flex flex-col gap-1">
        <UiAlertTitle v-if="title">
          {{ title }}
        </UiAlertTitle>
        <slot name="description">
          <UiAlertDescription v-if="description">
            {{ description }}
          </UiAlertDescription>
        </slot>
      </div>
    </slot>
    <div
      v-if="$slots.action"
      :class="{ 'mt-1': !inlineActions }"
      class="flex flex-row gap-2"
    >
      <slot name="action" />
    </div>
  </div>
</template>
